"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HiddenInput = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const HiddenInput = (0, _styled.default)("input")`
    // These are all to position it on top of the icon so a screen reader's virtual cursor will
    // be positioned properly.
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    inset: 0;
    margin: 0;
    padding: 0;

    ${_ref => {
  let {
    isDisabled
  } = _ref;
  return !isDisabled ? "cursor: pointer;" : "";
}}
`;
exports.HiddenInput = HiddenInput;
//# sourceMappingURL=HiddenInput.js.map